<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('dc1')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright">
                    <div class="toptj">
                        <table style="width: 100%; margin-left: 10px;">
                            <tr style="font-weight: bolder;">
                                <td style="font-size:14px;line-height:30px;">
                                    &nbsp;{{bookName}} {{$t('dc2')}}<i style="font-size:16px;color: red;">{{v1}}</i><br/>
                                    &nbsp;{{bookName}} {{$t('dc3')}}<i style="font-size:16px;color: red;">{{v2}}</i><br/>
                                    <!-- &nbsp;{{bookName}} {{$t('dc4')}}<i style="font-size:16px;color: red;">{{v3}}</i><br/> -->
                                    &nbsp;{{bookName}} {{$t('dc5')}}<i style="font-size:16px;color: red;">{{v4}}</i><br/>
                                </td>
                                <td style="font-size:14px;line-height:30px;">
                                    &nbsp;{{bookName}} {{$t('dc6')}}<i style="font-size:16px;color: red;">{{v5}}</i><br/>
                                    &nbsp;{{bookName}} {{$t('dc7')}}<i style="font-size:16px;color: red;">{{v6}}</i><br/>
                                    &nbsp;{{bookName}} {{$t('dc8')}}<i style="font-size:16px;color: red;">{{v7}}</i><br/>
                                </td>
                                <td style="font-size:14px;line-height:30px;">
                                    <!-- &nbsp;{{bookName}} {{$t('dc9')}}<i style="font-size:16px;color: red;">{{v9}}</i><br/> -->
                                    &nbsp;{{bookName}} {{$t('dc10')}}<i style="font-size:16px;color: red;">{{v8}}</i><br/>
                                    &nbsp;{{bookName}} {{$t('dc11')}}<i style="font-size:16px;color: red;">{{v10}}</i><br/>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('dc12')">
                                    <el-input v-model="searchform.employeeName" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('groupName')">
                                    <el-select size="small" v-model="searchform.groupId" style="width:180px;" :placeholder="$t('qxzrole')"  >
                                        <el-option :label="$t('buxian')" :value="0"></el-option>
                                        <el-option v-for="(item,index) in grouplist" :label="item.groupName" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('p20')">
                                    <el-date-picker
                                        v-model="value1"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div v-loading="loading">
                        <el-table :data="list"
                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                            <el-table-column prop="accountBook" :label="$t('paymentDays')"></el-table-column>
                            <el-table-column prop="groupName" :label="$t('groupName')"></el-table-column>
                            <el-table-column prop="employeeName" :label="$t('dc12')"></el-table-column>
                            <el-table-column prop="orderToday" :label="$t('dc22')"></el-table-column>
                            <el-table-column :formatter="formatInteres" prop="orderPayMoney" :label="$t('dc24')"></el-table-column>
                            <el-table-column :formatter="formatInteres" prop="orderToMoneyRate" :label="$t('dc25')"></el-table-column>
                            <el-table-column prop="orderToMoney" :label="$t('dc23')"></el-table-column>
                            <el-table-column prop="currentprocessed" :label="$t('dc13')"></el-table-column>
                            <el-table-column prop="completeDay" :label="$t('dc14')"></el-table-column>
                            <el-table-column prop="dayNewRate" :label="$t('dc15')"></el-table-column>
                            <el-table-column prop="remainderRepaid" :label="$t('dc16')"></el-table-column>
                            <el-table-column prop="monthlyRate" :label="$t('dc17')"></el-table-column>
                            <el-table-column prop="monthlyNewRate" :label="$t('dc18')"></el-table-column>
                            <el-table-column prop="yesterdayNew" :label="$t('dc19')"></el-table-column>
                            <el-table-column prop="yesterdayEcho" :label="$t('dc20')"></el-table-column>
                            <el-table-column prop="yesterdayRate" :label="$t('dc21')"></el-table-column>
                       
                            <el-table-column prop="coverageRate" :label="$t('re19')"></el-table-column>
                            <el-table-column prop="numberTotal" :label="$t('re20')"></el-table-column>
                            <el-table-column prop="callCompletingRate" :label="$t('re21')"></el-table-column>
                            <el-table-column prop="callDuration" :label="$t('re22')"></el-table-column>
                        </el-table>
                        <div class="page">
                            <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                                @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        components: {
            Treeselect
        },
        data() {
            return {
                v1: 0,
                v2: 0,
                v3: 0,
                v4: 0,
                v5: 0,
                v6: 0,
                v7: 0,
                v8: 0,
                v9: 0,
                v10: 0,
                searchform: {
                    blurry: "",
                },
                loading: false,
                list: [],
                total: 1,
                pageNo: 1,
                pageSize: 10,
                grouplist:[],
                bookName : null,
                value1:null,
            }
        },
        created() {
            this.user = JSON.parse(localStorage.getItem("userinfo"))
            this.bookName = this.$route.query.bookName
            this.getList()
            this.getgrouplist()
            this.getTotalData()
        },
        methods: {
            formatInteres(row, column, value) {
                // 将值转换为数字，若转换失败则返回原值
                const number = Number(value);
                return isNaN(number) ? value : number.toLocaleString('en-US');
            },
            getgrouplist(){
                _api.get(apiurl.groupAll, {
                }).then(res => {
                    this.grouplist = res.data
                })
            },
            getTotalData() {
                _api.get(apiurl.daycall, {
                    accountId:this.$route.query.accountId,
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.v1 = res.data.v1
                    this.v2 = res.data.v2
                    this.v3 = res.data.v3
                    this.v4 = res.data.v4
                    this.v5 = res.data.v5
                    this.v6 = res.data.v6
                    this.v7 = res.data.v7
                    this.v8 = res.data.v8
                    this.v9 = res.data.v9
                    this.v10 = res.data.v10
                })
            },
            getList() {
                this.loading = true
                _api.get(apiurl.queryCall, {
                    page: this.pageNo,
                    size: this.pageSize,
                    employeeName: this.searchform.employeeName,
                    groupId: this.searchform.groupId,
                    nation: localStorage.getItem("nation"),
                    accountId: this.$route.query.accountId,
                    createTime: this.value1
                }).then(res => {
                    this.loading = false
                    this.list = res.data.data
                    this.total = res.data.totalCount
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }
    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
    .toptj{ 
        display: flex; 
        margin: 5px 0;
        border: #ebedf0 solid 2px; 
        background: #ffffff; 
        height: 136px; 
    }
</style>